import { render, staticRenderFns } from "./modalAddNewRbacAccess.vue?vue&type=template&id=2ec29edf&"
import script from "./modalAddNewRbacAccess.vue?vue&type=script&lang=js&"
export * from "./modalAddNewRbacAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports